<template>
  <DialogForm v-model:visible="visible" :form :loading placement="left" :reset-on-dialog-close="false" :submit-text="$t('submit')" :title="$t('data')" @submit="submit">
    <p class="font-medium" style="margin-bottom: 15px">{{ $t('use-this-form-when-you-notice-missing-outdated-or-incorrect-data') }}</p>

    <VSelect v-model="form.data_bug" :label="$t('category')" prop="data_bug">
      <VOption :label="$t('general')" value="general" />
      <VOption :label="$t('bug')" value="bug" />
      <VOption :label="$t('request')" value="request" />
    </VSelect>

    <VTextarea v-if="form.data_bug !== null" v-model="form.description" :label="$t('describe-the-issue')" :maxlength="2000" prop="description" :rows="4" />

    <template v-if="form.data_bug && $env.app_env !== 'production'">
      <p class="font-medium" style="margin-bottom: 10px">{{ $t('please-give-a-hit-id-regarding-your-bug') }}</p>
      <VInput v-model="form.hit_id" label="Hit id" />
    </template>

    <p class="font-medium" style="margin-bottom: 10px">{{ $t('please-provide-the-related-source-if-relevant') }}</p>
    <VInput v-model="form.source" :label="$t('source')" />

    <VSelect v-model="form.follow_up_email" :label="$t('may-we-follow-up-on-the-given-feedback-via-email')">
      <VOption v-for="item in options" :key="item.label" :label="item.label" :value="item.value" />
    </VSelect>

    <VUpload :accept="$env.file_upload_all_extensions" drag :files="form.files" :max="5" multiple :pastable="visible" style="display: inline" @update:files="updateFiles" />
  </DialogForm>
</template>

<script setup lang="ts">
const visible = defineModel<boolean>('visible')

const loading = ref(false)
const options = [
  { label: $t('yes'), value: true },
  { label: $t('no'), value: false },
]

const form = useForm(
  {
    description: '',
    hit_id: '',
    source: '',
    data_bug: 'general',
    follow_up_email: true,
    files: [] as File[],
  },
  {
    rules: {
      description: { required: true, max: 2000, message: $t('please-describe-the-issue') },
    },
  },
)

function updateFiles(files: File[]) {
  if (files.some((file) => file.size > 2000000)) {
    $message.error('File is too large. The maximum size is 2MB')

    return
  }

  form.files = files
}

async function submit() {
  loading.value = true

  const payload = {
    ...form.data(),
    data_bug: form.data_bug === 'bug',
    title: form.description.split('\n')[0].split('. ')[0].slice(0, 180),
    url: document.location.href,
  }

  try {
    await api.postForm('data-request', payload)
    form.reset()
    $message.success($t('your-report-was-successfully-submitted'))
  } catch {
    $message.error($t('api-error'))
  }

  loading.value = false
}
</script>
